import { API_ROOT } from 'packages/http_client/utils';

export const ARTICLES_API = `${API_ROOT}/article`;

export const test2 = '';
